module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/place_tomog-7274e178d6fe7fdc6eefe4be175cde23.jpg";